import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  getMenus,
  getPagesAccess,
  getSpecialAccessUsernames,
} from "src/store/Authentication/authSelectors";
import { canShowPagePath } from "src/services/Authentication/AccessService";
import { RootState } from "src/store/reducers";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

interface IAutoCompleteOption {
    id: number,
    label: string,
    path: string
}

const SearchForm = () => {

    const menu = useSelector(getMenus());
    const pagesAccess = useSelector(getPagesAccess());
    const username = useSelector((state: RootState) => state.auth.user?.username);
    const allowedUsernames = useSelector(getSpecialAccessUsernames);

    const options = useMemo(() => {
        const pagesAccessURLS: string[] = pagesAccess?.map((page: any) => page.pageURL) || [];
        const tempOpciones: IAutoCompleteOption[] = [];
        menu?.forEach((menuItem) => {
            menuItem.groups
                .filter(group => group.items.some(item => canShowPagePath(item.pathURL, pagesAccessURLS, username, allowedUsernames)))
                .forEach((group) => {
                    group.items
                        .filter(item => canShowPagePath(item.pathURL, pagesAccessURLS, username, allowedUsernames))
                        .forEach((item) => {
                            const newName = item.name == "Facturas" || item.name == "Notas de Crédito ERP" || item.name == "Pagos"
                                ? `${item.name} (${group.name})`
                                : item.name;
                            tempOpciones.push({ id: item.menuId, label: newName, path: item.pathURL });
                        });
                });
        });
        return tempOpciones;
    }, [menu, pagesAccess, username, allowedUsernames]);

    return (
        <div className="navbar-form custom-navbar-form" style={{ margin: 0, padding: 0, marginRight: 'auto' }}>
            <div>
                <div className="form-group" style={{ display: 'flex', alignItems: 'center' }}>
                    <Typeahead
                        id="menu-search"
                        labelKey="label"
                        options={options}
                        className="custom-typehead"
                        placeholder="Buscar..."
                        filterBy={['label']}
                        onChange={(e: any) => {
                            const {path} = e[0]
                            if(path) {
                                window.location.href
                                    ? (window.location.href =
                                        window.location.origin + path)
                                    : (window.location.href =
                                        window.location.origin + path);
                            }
                        }} 
                    />
                    <button type="submit" className="btn btn-search btn-no-bg-only shadow-none"><i className="fa fa-search"></i></button>
                </div>
            </div>
        </div>
    );
}

export default SearchForm;